/**
 * Workaround class used to execute an action from one event context after the execution of another posterior event.
 * It was designe for support to update the title of a model after an child fetch updateds the information.
 * example:
 * ```
 * onAfterExcute: DelayedExecutor<GuidanceAndRegulatory> = new DelayedExecutor();
 *
 * onEventOne(event){
 *    this.onAfterExcute.onCompleted(e => {
 *        const rootModal: ModalAPI = event.target;
 *        rootModal.setTitle(e.nmTermo);
 *    })
 * }
 *
 * onEventTwo(){
 *    this.onAfterExcute.completeNow(data);
 * }
 *
 * ```
 */
export class DelayedExecutor<T>{

  private uniqueOnCompleteAction: ((data: T) => void)[];

  constructor() {
    this.uniqueOnCompleteAction = [];
  }

  completeNow(data: T): void {
    if (!this.uniqueOnCompleteAction || this.uniqueOnCompleteAction.length === 0) {
      return;
    }
    this.uniqueOnCompleteAction.forEach(fn => setTimeout(() => fn(data), 0));
    this.uniqueOnCompleteAction = [];
  }

  onCompleted(fn: (data: T) => void): void {
    this.uniqueOnCompleteAction.push(fn);
  }

}